import React, { Component } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { ActionCreators } from './redux/actions';
class PrivateRoute extends Component {
  render() {
    // const {component: Component, app, ...rest} = this.props;
    const {
      component: AppComponent,
      privilege,
      app,
      location
    } = this.props;

    if (app.auth === null) {
      const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
      return (
        <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
          <Spin indicator={antIcon} />
        </div>
      )
    }
    let logoutWay = app.logoutWay;

    return (
      <Route
        render={props => {
          if (app.auth) {
            if (privilege === 'admin' && app.admin.admin_id) {
              return <AppComponent state={location.state} />
            }
            if (privilege === 'admin' && !app.admin.admin_id) {
              return <Redirect to="/login" />
            }
          }
          if (logoutWay === 'admin') {
            return <Redirect to="/login" />
          }

          //   return (
          //     app.auth
          //     ? <AppComponent {...props}/>
          //     : <Redirect to="/admin/login" />
          // )
        }} />
    );
  }
};

function mapStateToProps(state) {
  return {
    app: state.app
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateRoute);
